"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariantPicker = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Option = require("./Option");
var _utils = require("./utils");
require("./VariantPicker.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const VariantPicker = _ref => {
  let {
    variantGroups,
    hasSelectionError,
    onSelect,
    errorMessage
  } = _ref;
  const [availability, setAvailability] = (0, _react.useState)((0, _utils.getInitialAvailability)(variantGroups));
  const [highlights, setHighlights] = (0, _react.useState)({});
  const handleMouseOver = groupId => option => {
    if (variantGroups.length > 2) {
      return;
    }
    setAvailability((0, _utils.getAvailability)(variantGroups, option, groupId));
    setHighlights((0, _utils.getHighlights)(option));
  };
  const handleMouseOut = () => {
    setAvailability((0, _utils.getInitialAvailability)(variantGroups));
    setHighlights({});
  };
  const rootClassName = (0, _classnames.default)('cds-VariantPicker', {
    'cds-VariantPicker--ManyGroupHover': variantGroups?.length > 2
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, variantGroups.map(group => /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "cds-VariantGroup",
    key: group.id
  }, /*#__PURE__*/_react.default.createElement("legend", {
    className: "cds-VariantGroup-AttrName"
  }, group.label, ":", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-VariantGroup-AttrValue"
  }, group.selected)), /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-VariantPicker-List"
  }, group.options.map(option => {
    const isAvailable = (availability[group.id] || []).includes(option.value);
    const isHighlighted = (highlights[group.id] || []).includes(option.value);
    return /*#__PURE__*/_react.default.createElement(_Option.Option, (0, _extends2.default)({
      option: option,
      onSelect: onSelect
    }, variantGroups.length <= 2 && {
      onMouseOver: handleMouseOver(group.id),
      onMouseOut: handleMouseOut
    }, {
      isAvailable: isAvailable,
      isHighlighted: isHighlighted,
      key: option.value
    }));
  })))), hasSelectionError && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-VariantPicker-Error"
  }, errorMessage));
};
exports.VariantPicker = VariantPicker;
//# sourceMappingURL=VariantPicker.js.map